<template>
  <div>
    <div class="text-left mb-5">
      <span class="headline" id="headerlist">Product Type List</span>
    </div>
    <!-- Table Start -->
    <div class="holder">
      <div class="filter">
        <v-text-field
          v-model="filter"
          v-on:keyup="filterList"
          label="search by product type"
          append-icon="mdi-filter"
        />
      </div>
      <div class="paginate">
        <v-select
          v-model="paginationcount"
          v-on:change="paginateList"
          :items="paginationcounts"
          item-text="name"
          item-value="name"
          :selected="paginationcounts.value === 10"
          label="show by"
        ></v-select>
      </div>
    </div>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Product Type</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in productTypes" :key="item.id" @click="showProductType(item.id)">
            <td class="text-left">{{ item.name }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="4" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <v-btn
      fixed
      bottom
      right
      @click="$router.push('/producttype/create')"
      color="blue darken-2"
      dark
      fab
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <productTypeCreate
      v-if="create"
      :page="page"
      :create="create"
      @createChange="
        value => {
          this.create = value;
        }
      "
    />
    <productTypeEdit v-if="edit" :page="page" :edit="edit" />
    <productTypeShow v-if="show" :show="show" :page="page" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import productTypeCreate from './ProductTypeCreate';
import productTypeEdit from './ProductTypeEdit';
import productTypeShow from './ProductTypeShow';

export default {
  data: function() {
    return {
      page: 1,
      filter: '',
      paginationcount: '10'
    };
  },
  components: {
    productTypeCreate,
    productTypeEdit,
    productTypeShow
  },
  props: {
    create: false,
    show: false,
    edit: false
  },
  watch: {
    page(val) {
      this['ProductType/fetchProductTypes']({
        page: val,
        filter: this.filter,
        paginationcount: this.paginationcount
      });
    },
    $route(to, from) {
      if (this.show) {
        this['ProductType/getProductType']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      productTypes: state => state.ProductType.productTypes.data,
      paginationcounts: state => state.Unit.paginationcount,
      pagination: state => {
        if (state.ProductType.productTypes.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        return state.ProductType.productTypes;
      }
    })
  },
  mounted() {
    this['ProductType/fetchProductTypes']({
      page: this.page,
      paginationcount: this.paginationcount
    });
  },
  methods: {
    ...mapActions(['ProductType/fetchProductTypes', 'ProductType/getProductType']),
    showProductType(id) {
      let path = `/producttype/${id}`;
      if (this.$route.path !== path) this.$router.push(path);
    },
    filterList() {
      if (this.page !== 1) this.page = 1;
      else
        this['ProductType/fetchProductTypes']({
          page: this.page,
          filter: this.filter,
          paginationcount: this.paginationcount
        });
    },
    paginateList() {
      if (this.page !== 1) this.page = 1;
      else
        this['ProductType/fetchProductTypes']({ page: 1, paginationcount: this.paginationcount });
    }
  }
};
</script>
